var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconNotFound(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 160,
    height: 160,
    viewBox: "0 0 160 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1324_18157)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.0002 93.7293C124.039 93.7293 159.739 87.5825 159.739 80C159.739 72.4176 124.039 66.2708 80.0002 66.2708C35.9619 66.2708 0.261719 72.4176 0.261719 80C0.261719 87.5825 35.9619 93.7293 80.0002 93.7293Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.961 144.386C125.961 148.515 105.378 151.871 80.0003 151.871C54.623 151.871 34.04 148.515 34.04 144.386C34.04 140.256 54.6121 136.911 80.0003 136.911C105.388 136.911 125.961 140.256 125.961 144.386Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9998 128.488C118.718 128.488 150.106 123.38 150.106 117.08C150.106 110.779 118.718 105.672 79.9998 105.672C41.2812 105.672 9.89355 110.779 9.89355 117.08C9.89355 123.38 41.2812 128.488 79.9998 128.488Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0003 23.0782C105.383 23.0782 125.961 19.7316 125.961 15.6034C125.961 11.4752 105.383 8.1286 80.0003 8.1286C54.6171 8.1286 34.04 11.4752 34.04 15.6034C34.04 19.7316 54.6171 23.0782 80.0003 23.0782Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.9998 54.3286C118.718 54.3286 150.106 49.2209 150.106 42.9202C150.106 36.6196 118.718 31.5119 79.9998 31.5119C41.2812 31.5119 9.89355 36.6196 9.89355 42.9202C9.89355 49.2209 41.2812 54.3286 79.9998 54.3286Z",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1324_18157"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 160,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNotFound);
export default __webpack_public_path__ + "static/media/icon-not-found.f9e5fcbdeb246b780aa0da4c04b9335a.svg";
export { ForwardRef as ReactComponent };